import { CashOut } from "./CashOutOption"

export namespace SurrenderValuePaymentForAutoTerminatedPolicySubmission {
      export interface SubmitData {
        policy: {
          policyNo: string
        }
        attributesExt: {
          TOTAL_PAYOUT_AMOUNT: number
          AUTO_TERMINATED_POLICY_AMOUNT: number
        }
        // cashOutOptions: Array<CashOutOptions>
        cashOutOptions: Array<CashOut.Option>
      }
}